import ListHeader from "@/components/custom/ListHeader"
import NewsDetailSkeleton from "@/components/skeleton/news/news-detail-skeleton"
import { Typography } from "@/components/Typography"
import { useNewsInfoQuery, type NewsDetailRequest } from "@/service/api/news"
import { useState } from "react"
import { useParams } from "react-router-dom"

const NewsDetail = () => {
  const { id } = useParams<{ id: string }>()
  const parsedId = id ? Number(id) : 0

  const [newsDetail, setNewDetail] = useState<NewsDetailRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      newsId: parsedId,
    },
  })

  const { data: newsDetailData, isLoading } = useNewsInfoQuery(newsDetail)

  return (
    <div>
      <ListHeader title="News" />

      {isLoading ? (
        <NewsDetailSkeleton />
      ) : (
        <>
          <div className="flex py-2.5 px-4 gap-4 flex-start">
            <div className="size-10 shrink-0">
              <img
                src={newsDetailData?.profileUrl}
                alt="Profile Image"
                className="rounded-2xl"
              />
            </div>
            <div className="flex flex-col justify-center text-start">
              <Typography variant="body-small" className="leading-[20px]">
                {newsDetailData?.name}
              </Typography>
              <Typography
                variant="caption"
                className="font-normal leading-[20px]"
              >
                {newsDetailData?.regDt}
              </Typography>
            </div>
          </div>

          <div className="p-4 text-start">
            <Typography variant="body-medium">
              {newsDetailData?.title}
            </Typography>
            <Typography variant="body-small" className="mt-3 mb-6">
              {newsDetailData?.contents}
            </Typography>
            <div>
              <img
                src={newsDetailData?.thumbImageUrl}
                alt="Thumb Image"
                className="rounded-xl"
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default NewsDetail
